import DropDown from './components/Dropdown'
import LoadingContent from '@/components/LoadingContent'
import ErrorIndicator from '@/components/Validation/ErrorIndicator'

import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"

import VModal from 'vue-js-modal'
import {Modal, SimpleModal, ImageWithFallback} from '@/components'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('drop-down', DropDown)
    Vue.component('loading-content', LoadingContent)
    Vue.component('error-indicator', ErrorIndicator)
    Vue.component('modal', Modal)
    Vue.component('simple-modal', SimpleModal)
    Vue.component('img-with-fallback', ImageWithFallback)

		Vue.use(VModal, { componentName: "v-modal" })

	 // register globally
	 Vue.component('multiselect', Multiselect)
  },
}

export default GlobalComponents


// WEBPACK FOOTER //
// ./src/globalComponents.js